import hash from 'object-hash'

const objectHash = {
	methods: {
		generateUniqueHash: (obj) => {
			return hash(obj)
		}
	}
}

export default objectHash